/* Be Happy Be You — Supplement Facts modal
   - Delegated triggers: any [data-bhby-facts] click opens a modal with the label's
     JSON array of { t: title, s: imageSrc }.
   - BYOB injector: reads window.BHBY_FACTS (handle -> {t,s}) and injects a
     "See supplement facts" trigger into each Build-Your-Own picker card. */
(function () {
  if (window.__bhbyFactsModal) return;
  window.__bhbyFactsModal = true;

  var modal, body, lastFocus;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'bhby-fm';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="bhby-fm__backdrop" data-fm-close></div>' +
      '<div class="bhby-fm__dialog" role="dialog" aria-modal="true" aria-label="Supplement facts">' +
      '<button type="button" class="bhby-fm__close" data-fm-close aria-label="Close">&times;</button>' +
      '<div class="bhby-fm__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.bhby-fm__body');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-fm-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) close();
    });
  }

  function render(items) {
    var multi = items.length > 1;
    var html = '';
    var title = multi ? 'Supplement facts' : ((items[0] && items[0].t) ? items[0].t : 'Supplement facts');
    html += '<h2 class="bhby-fm__title">' + esc(title) + '</h2>';
    items.forEach(function (it) {
      if (!it || !it.s) return;
      html += '<figure class="bhby-fm__item">';
      if (multi && it.t) html += '<figcaption class="bhby-fm__cap">' + esc(it.t) + '</figcaption>';
      html +=
        '<img class="bhby-fm__img" src="' + esc(it.s) + '" alt="' +
        esc(it.t || 'Supplement facts') + ' supplement facts label" decoding="async">';
      html += '</figure>';
    });
    html +=
      '<p class="bhby-fm__disclaimer">These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</p>';
    body.innerHTML = html;
  }

  function open(items) {
    if (!items || !items.length) return;
    if (!modal) build();
    render(items);
    lastFocus = document.activeElement;
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('bhby-fm-open');
    var c = modal.querySelector('.bhby-fm__close');
    if (c) c.focus();
  }

  function close() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('bhby-fm-open');
    body.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bhby-facts]');
    if (!t) return;
    e.preventDefault();
    var items;
    try { items = JSON.parse(t.getAttribute('data-bhby-facts')); } catch (err) { items = []; }
    open(items);
  });

  window.BHBYFactsModal = { open: open, close: close };

  /* ---- BYOB per-card injector ---- */
  function handleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function injectByob() {
    var map = window.BHBY_FACTS;
    if (!map) return 0;
    var cards = document.querySelectorAll('li.byob-bundle__product-card');
    var done = 0;
    cards.forEach(function (card) {
      if (card.querySelector('.bhby-facts-trigger')) { done++; return; } // already injected
      var link = card.querySelector('a.byob-options-modal__details-link, a[href*="/products/"]');
      var handle = handleFromHref(link && link.getAttribute('href'));
      var data = handle && map[handle];
      if (!data || !data.s) return;
      var meta = card.querySelector('.byob-bundle__product-card-price') ||
        card.querySelector('.byob-bundle__product-card-title') ||
        card.querySelector('.byob-bundle__product-card-meta');
      if (!meta) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bhby-facts-trigger';
      btn.setAttribute('data-bhby-facts', JSON.stringify([{ t: data.t, s: data.s }]));
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="3" width="16" height="18" rx="2"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/></svg>' +
        '<span>See supplement facts</span>';
      meta.insertAdjacentElement('afterend', btn);
      done++;
    });
    return { cards: cards.length, done: done };
  }

  function initByob() {
    if (!window.BHBY_FACTS) return;
    var mo;
    var raf = 0;
    function run() {
      var r = injectByob();
      // Once every present card has a button (and there is at least one), stop watching.
      if (r && r.cards > 0 && r.done >= r.cards && mo) { mo.disconnect(); }
    }
    injectByob();
    mo = new MutationObserver(function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; run(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // Belt-and-suspenders: the BYOB picker hydrates asynchronously.
    [300, 800, 1500, 3000, 5000].forEach(function (t) { setTimeout(run, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initByob);
  } else {
    initByob();
  }
})();
